module.exports = "/* .collection, .collection-item {\n  background-color: white;\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/customers/customers.component.css
// module id = ./src/app/components/customers/customers.component.css
// module chunks = main